import {
    Container,
    Graphics,
    Text,
} from 'pixi.js';
import { SCREEN_HEIGHT, SCREEN_WIDTH, FONT_UI } from '../GameConst';

export class InfoTextBar extends Container {
    constructor(text){
        super();

        const background = new Graphics().beginFill(0x000000, 0.75).drawRect(0, 0, SCREEN_WIDTH * 0.6, 80);
        this.addChild(background);

        const infoText = new Text(text, {
            fontFamily: FONT_UI,
            fontSize: 30,
            fill: 'white',
        });
        infoText.anchor.set(0, 0.5);
        infoText.x = 50;
        infoText.y = background.height * 0.5;
        this.addChild(infoText);

        this.y = SCREEN_HEIGHT * 0.3;
    }
}
